/**
 * Obtiene los parámetros del tablero para el spread especificado.
 *
 * Esta función calcula y devuelve los parámetros necesarios para configurar
 * el tablero de cartas según el spread y el tema de tarot.
 *
 * @param {string} spread - El spread de tarot seleccionado.
 * @param {NodeList} cards - La lista de cartas en el tablero.
 * @param {number} tableroMedidas_x - El ancho del tablero.
 * @param {Object} tarot_theme - El tema de tarot que contiene los parámetros de configuración.
 *
 * @returns {Object} Un objeto que contiene los parámetros del tablero.
 */
export default function (spread, cards, imgBorde, tarot_theme, root) {
  let proportionImg,
    ImgWidth,
    y_tablero,
    x_tablero,
    padding,
    moveCruz;

  // Polyfill: NodeList.forEach para navegadores antiguos
  (function(){
    if (typeof window !== 'undefined' && typeof NodeList !== 'undefined' && !NodeList.prototype.forEach) {
      NodeList.prototype.forEach = function(callback, thisArg){
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
          callback.call(thisArg, this[i], i, this);
        }
      };
    }
  })();

  // Utilidades numéricas seguras
  var toNum = function(v, d){ var n = parseFloat(v); return (isFinite(n) ? n : d); };
  var clamp = function(n, min, max){ return Math.max(min, Math.min(max, n)); };

  // Orientación por defecto vertical
  const image_orientation = (tarot_theme && tarot_theme.tkta_image_orientation) ? tarot_theme.tkta_image_orientation : 'v';

  // Parámetros del tablero con fallback seguro si no existen en el tema
  const tablero_parameters = (tarot_theme && tarot_theme.spread_parameters && tarot_theme.spread_parameters[spread]) || {
    // Desktop
    tablero_size_card: 20,
    tablero_padding_cards: 0.05,
    // Mobile
    tablero_size_card_mov: 24,
    tablero_padding_cards_mov: 0.06,
  };

  if (image_orientation === "v") { // Vertical
  var tablero_size_card = tablero_parameters.tablero_size_card;
    var tablero_padding_cards = tablero_parameters.tablero_padding_cards;

  var tablero_size_card_mov = tablero_parameters.tablero_size_card_mov;
    var tablero_padding_cards_mov = tablero_parameters.tablero_padding_cards_mov;

  } else { // Horizontal
  var tablero_size_card = tablero_parameters.tablero_size_card * 1.5;
    var tablero_padding_cards = tablero_parameters.tablero_padding_cards - 0.3;

  var tablero_size_card_mov = tablero_parameters.tablero_size_card_mov * 1.5;
    var tablero_padding_cards_mov = tablero_parameters.tablero_padding_cards_mov - 0.3;
  }

  // Normalizar y acotar valores para evitar NaN o extremos
  tablero_size_card = clamp(toNum(tablero_size_card, 20), 5, 90);
  tablero_padding_cards = clamp(toNum(tablero_padding_cards, 0.05), 0, 2);

  tablero_size_card_mov = clamp(toNum(tablero_size_card_mov, 24), 5, 90);
  tablero_padding_cards_mov = clamp(toNum(tablero_padding_cards_mov, 0.06), 0, 2);


  // Scopear la consulta al contenedor de la instancia (root) para multi‑instancia
  const scopeEl = (root && typeof root.querySelector === 'function') ? root : document;
  const tablero = scopeEl.querySelector(".tablero");
  let tableroMedidas_x = 0;
  if (tablero) {
    let rectTablero_pre = tablero.getBoundingClientRect();
    tableroMedidas_x = rectTablero_pre.width;
  }


  
  switch (spread) {
    // Default spreads
    case "1cards":
      if (window.innerWidth >= 768) {
        // Escritorio
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card) / 100; // tablero, tamaño de las cartas.
        y_tablero = (ImgWidth / proportionImg) * 0; // tablero, mover arriba o abajo. Valido numeros negativos
  x_tablero = 0;
        padding = ImgWidth * tablero_padding_cards; // tablero, Espaciado entre cartas

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto"; 
        });

      } else {
        // Movil
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card_mov) / 100; // tablero, tamaño de las cartas.
        y_tablero = (ImgWidth / proportionImg) * 0; // tablero, mover arriba o abajo. Valido numeros negativos
  x_tablero = 0;
        padding = ImgWidth * tablero_padding_cards_mov; // tablero, Espaciado entre cartas

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto"; 
        });

      }
      break;

    case "0cards":
      if (window.innerWidth >= 768) {
        // Escritorio
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card) / 100; // tablero, tamaño de las cartas.
        y_tablero = (ImgWidth / proportionImg) * 0; // tablero, mover arriba o abajo. Valido numeros negativos
  x_tablero = 0;
        padding = ImgWidth * tablero_padding_cards; // tablero, Espaciado entre cartas

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto"; 
        });

      } else {
        // Movil
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card_mov) / 100; // tablero, tamaño de las cartas.
        y_tablero = (ImgWidth / proportionImg) * 0; // tablero, mover arriba o abajo. Valido numeros negativos
  x_tablero = 0;
        padding = ImgWidth * tablero_padding_cards_mov; // tablero, Espaciado entre cartas

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto"; 
        });

      }
      break;

  case "2cards":
      if (window.innerWidth >= 768) {
        // Escritorio
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card) / 100; // tablero, tamaño de las cartas.
        y_tablero = (ImgWidth / proportionImg) * 0; // tablero, mover arriba o abajo. Valido numeros negativos
  x_tablero = 0;
        padding = ImgWidth * tablero_padding_cards; // tablero, Espaciado entre cartas

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto"; 
        });

      } else {
        // Movil
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card_mov) / 100; // tablero, tamaño de las cartas.
        y_tablero = (ImgWidth / proportionImg) * 0; // tablero, mover arriba o abajo. Valido numeros negativos
  x_tablero = 0;
        padding = ImgWidth * tablero_padding_cards_mov; // tablero, Espaciado entre cartas

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto"; 
        });

      }
      break;

      case "3cards":
        if (window.innerWidth >= 768) {
          // Escritorio
          proportionImg = 100 / 10; // no cambiar
          ImgWidth = (tableroMedidas_x * tablero_size_card) / 100; // tablero, tamaño de las cartas.
          y_tablero = (ImgWidth / proportionImg) * 0; // tablero, mover arriba o abajo. Valido numeros negativos
          x_tablero = 0;
          padding = ImgWidth * tablero_padding_cards; // tablero, Espaciado entre cartas
  
          imgBorde.forEach(function (t) {
            t.style.width = ImgWidth + "px";
            t.style.height = "auto"; 
          });
  
        } else {
          // Movil
          proportionImg = 100 / 10; // no cambiar
          ImgWidth = (tableroMedidas_x * tablero_size_card_mov) / 100; // tablero, tamaño de las cartas.
          y_tablero = (ImgWidth / proportionImg) * 0; // tablero, mover arriba o abajo. Valido numeros negativos
          x_tablero = 0;
          padding = ImgWidth * tablero_padding_cards_mov; // tablero, Espaciado entre cartas
  
          imgBorde.forEach(function (t) {
            t.style.width = ImgWidth + "px";
            t.style.height = "auto"; 
          });
  
        }
        break;

    case "4cards":
      if (window.innerWidth >= 768) {
        // Escritorio
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card) / 100; // tablero, tamaño de las cartas.
        y_tablero = (ImgWidth / proportionImg) * 0; // tablero, mover arriba o abajo. Valido numeros negativos
  x_tablero = 0;
        padding = ImgWidth * tablero_padding_cards; // tablero, Espaciado entre cartas

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto"; 
        });

      } else {
        // Movil
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card_mov) / 100; // tablero, tamaño de las cartas.
        y_tablero = (ImgWidth / proportionImg) * 0; // tablero, mover arriba o abajo. Valido numeros negativos
  x_tablero = 0;
        padding = ImgWidth * tablero_padding_cards_mov; // tablero, Espaciado entre cartas

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto"; 
        });

      }
      
      break;

    case "5cards":
      if (window.innerWidth >= 768) {
        // Escritorio
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card) / 100; // tablero, tamaño de las cartas.
        y_tablero = (ImgWidth / proportionImg) * 0; // tablero, mover arriba o abajo. Valido numeros negativos
  x_tablero = 0;
        padding = ImgWidth * tablero_padding_cards; // tablero, Espaciado entre cartas

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto"; 
        });

      } else {
        // Movil
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card_mov) / 100; // tablero, tamaño de las cartas.
        y_tablero = (ImgWidth / proportionImg) * 0; // tablero, mover arriba o abajo. Valido numeros negativos
  x_tablero = 0;
        padding = ImgWidth * tablero_padding_cards_mov; // tablero, Espaciado entre cartas

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto"; 
        });

      }
      
      break;

  case "6cards":
      if (window.innerWidth >= 768) {
        // Escritorio
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card) / 100; // tablero, tamaño de las cartas.
        y_tablero = (ImgWidth / proportionImg) * -9; // tablero, mover arriba o abajo. Valido numeros negativos
        x_tablero = 0;
  // Altura automática eliminada
        padding = ImgWidth * tablero_padding_cards; // tablero, Espaciado entre cartas

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto"; 
        });

      } else {
        // Movil
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card_mov) / 100; // tablero, tamaño de las cartas.
        y_tablero = (ImgWidth / proportionImg) * -9; // tablero, mover arriba o abajo. Valido numeros negativos
        x_tablero = 0;
  // Altura automática eliminada
        padding = ImgWidth * tablero_padding_cards_mov; // tablero, Espaciado entre cartas

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto"; 
        });

      }
      
      break;

  case "7cards":
      if (window.innerWidth >= 768) {
        // Escritorio
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card) / 100; // tablero, tamaño de las cartas.
        y_tablero = (ImgWidth / proportionImg) * -9; // tablero, mover arriba o abajo. Válido negativos
        x_tablero = 0;
  // Altura automática eliminada
        padding = ImgWidth * tablero_padding_cards; // tablero, Espaciado entre cartas

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto";
        });

      } else {
        // Móvil
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card_mov) / 100; // tablero, tamaño de las cartas.
        y_tablero = (ImgWidth / proportionImg) * -9; // tablero, mover arriba o abajo. Válido negativos
        x_tablero = 0;
  // Altura automática eliminada
        padding = ImgWidth * tablero_padding_cards_mov; // tablero, Espaciado entre cartas

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto";
        });

      }
      
      break;

  case "8cards":
      if (window.innerWidth >= 768) {
        // Escritorio
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card) / 100; // tablero, tamaño de las cartas.
        y_tablero = (ImgWidth / proportionImg) * -9; // tablero, mover arriba o abajo. Válido negativos
        x_tablero = 0;
  // Altura automática eliminada
        padding = ImgWidth * tablero_padding_cards; // tablero, Espaciado entre cartas

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto";
        });

      } else {
        // Móvil
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card_mov) / 100; // tablero, tamaño de las cartas.
        y_tablero = (ImgWidth / proportionImg) * -9; // tablero, mover arriba o abajo. Válido negativos
        x_tablero = 0;
  // Altura automática eliminada
        padding = ImgWidth * tablero_padding_cards_mov; // tablero, Espaciado entre cartas

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto";
        });

      }
      
      break;

    case "9cards":
      if (window.innerWidth >= 768) {
        // Escritorio
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card) / 100; // tablero, tamaño de las cartas.
        y_tablero = (ImgWidth / proportionImg) * -9; // tablero, mover arriba o abajo. Válido negativos
        x_tablero = 0;
        padding = ImgWidth * tablero_padding_cards; // tablero, Espaciado entre cartas

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto";
        });

      } else {
        // Móvil
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card_mov) / 100; // tablero, tamaño de las cartas.
        y_tablero = (ImgWidth / proportionImg) * -9; // tablero, mover arriba o abajo. Válido negativos
        x_tablero = 0;
        padding = ImgWidth * tablero_padding_cards_mov; // tablero, Espaciado entre cartas

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto";
        });

      }
      
      break;

    case "10cards":
      if (window.innerWidth >= 768) {
        // Escritorio
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card) / 100; // tablero, tamaño de las cartas.
        y_tablero = (ImgWidth / proportionImg) * -9; // tablero, mover arriba o abajo. Válido negativos
        x_tablero = 0;
        padding = ImgWidth * tablero_padding_cards; // tablero, Espaciado entre cartas

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto";
        });

      } else {
        // Móvil
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card_mov) / 100; // tablero, tamaño de las cartas.
        y_tablero = (ImgWidth / proportionImg) * -9; // tablero, mover arriba o abajo. Válido negativos
        x_tablero = 0;
        padding = ImgWidth * tablero_padding_cards_mov; // tablero, Espaciado entre cartas

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto";
        });

      }
      
      break;

    // Classic spreads
    case "3cards1":
       if (window.innerWidth >= 768) {
          // Escritorio
          proportionImg = 100 / 10; // no cambiar
          ImgWidth = (tableroMedidas_x * tablero_size_card) / 100; // tablero, tamaño de las cartas.
          y_tablero = (ImgWidth / proportionImg) * 13; // tablero, mover arriba o abajo. Valido numeros negativos
          x_tablero = 0;
          padding = ImgWidth * tablero_padding_cards; // tablero, Espaciado entre cartas
  
          imgBorde.forEach(function (t) {
            t.style.width = ImgWidth + "px";
            t.style.height = "auto"; 
          });
  
        } else {
          // Movil
          proportionImg = 100 / 10; // no cambiar
          ImgWidth = (tableroMedidas_x * tablero_size_card_mov) / 100; // tablero, tamaño de las cartas.
          y_tablero = (ImgWidth / proportionImg) * 13; // tablero, mover arriba o abajo. Valido numeros negativos
          x_tablero = 0;
          padding = ImgWidth * tablero_padding_cards_mov; // tablero, Espaciado entre cartas
  
          imgBorde.forEach(function (t) {
            t.style.width = ImgWidth + "px";
            t.style.height = "auto"; 
          });
  
        }
      break;

    case "3cards2":
      if (window.innerWidth >= 768) {
        // Escritorio (igual patrón que 3cards1)
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card) / 100; // tablero, tamaño de las cartas.
        y_tablero = (ImgWidth / proportionImg) * 5; // empuja el conjunto hacia abajo en desktop
  x_tablero = 0;
        padding = ImgWidth * tablero_padding_cards; // tablero, Espaciado entre cartas

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto"; 
        });

      } else {
        // Móvil (igual patrón que 3cards1)
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card_mov) / 100; // tablero, tamaño de las cartas.
        y_tablero = (ImgWidth / proportionImg) * 5; // sin empuje vertical extra
  x_tablero = 0;
        padding = ImgWidth * tablero_padding_cards_mov; // tablero, Espaciado entre cartas

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto"; 
        });

      }
      
      break;

    case "4cards2":
      if (window.innerWidth >= 768) {
        // Escritorio (referencia: Default 4cards)
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card) / 100; // tablero, tamaño de las cartas.
        y_tablero = (ImgWidth / proportionImg) * 0; // centrado vertical similar a 4cards
  x_tablero = 0;
        padding = ImgWidth * tablero_padding_cards; // tablero, Espaciado entre cartas

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto"; 
        });

      } else {
        // Móvil (referencia: Default 4cards)
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card_mov) / 100; // tablero, tamaño de las cartas.
        y_tablero = (ImgWidth / proportionImg) * 0; // centrado vertical similar a 4cards
  x_tablero = 0;
        padding = ImgWidth * tablero_padding_cards_mov; // tablero, Espaciado entre cartas

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto"; 
        });

      }
      
      break;

    case "4cards1":
      if (window.innerWidth >= 768) {
        // Escritorio (cruz: requiere altura extra para arriba/abajo)
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card) / 100; // tablero, tamaño de las cartas.
        y_tablero = (ImgWidth / proportionImg) * 0; // centrado vertical
        x_tablero = 0;
  // Altura automática eliminada
        padding = ImgWidth * tablero_padding_cards; // tablero, Espaciado entre cartas

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto"; 
        });

      } else {
        // Móvil (cruz: altura doble igualmente)
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card_mov) / 100; // tablero, tamaño de las cartas.
        y_tablero = (ImgWidth / proportionImg) * 0; // centrado vertical
        x_tablero = 0;
  // Altura automática eliminada
        padding = ImgWidth * tablero_padding_cards_mov; // tablero, Espaciado entre cartas

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto"; 
        });

      }
      
      break;

    case "5cards3":
      if (window.innerWidth >= 768) {
        // Escritorio (cruz + centro): altura doble para acomodar arriba/abajo
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card) / 100; // tamaño de las cartas
        y_tablero = (ImgWidth / proportionImg) * 0; // centrado vertical
        x_tablero = 0;
  // Altura automática eliminada
        padding = ImgWidth * tablero_padding_cards; // espaciado entre cartas

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto";
        });

      } else {
        // Móvil (misma lógica con valores móviles)
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card_mov) / 100; // tamaño de las cartas
        y_tablero = (ImgWidth / proportionImg) * 0; // centrado vertical
        x_tablero = 0;
  // Altura automática eliminada
        padding = ImgWidth * tablero_padding_cards_mov; // espaciado entre cartas

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto";
        });

      }
      break;

    case "5cards1":
      if (window.innerWidth >= 768) {
        // Escritorio (flecha hacia arriba): altura 1.5x para acomodar el pico superior
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card) / 100; // tamaño cartas
        y_tablero = (ImgWidth / proportionImg) * 9; // centrado vertical
        x_tablero = 0;
  // Altura automática eliminada
        padding = ImgWidth * tablero_padding_cards; // espaciado

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto"; 
        });

      } else {
        // Móvil
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card_mov) / 100; // tamaño cartas
        y_tablero = (ImgWidth / proportionImg) * 9; // centrado vertical
        x_tablero = 0;
  // Altura automática eliminada
        padding = ImgWidth * tablero_padding_cards_mov; // espaciado

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto"; 
        });

      }

      break;

    case "5cards2":
      if (window.innerWidth >= 768) {
        // Escritorio (flecha hacia abajo): misma altura 1.5x que 5cards1
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card) / 100; // tamaño cartas
        y_tablero = (ImgWidth / proportionImg) * -8; // centrado vertical
        x_tablero = 0;
  // Altura automática eliminada
        padding = ImgWidth * tablero_padding_cards; // espaciado

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto"; 
        });

      } else {
        // Móvil
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card_mov) / 100; // tamaño cartas
        y_tablero = (ImgWidth / proportionImg) * -8; // centrado vertical
        x_tablero = 0;
  // Altura automática eliminada
        padding = ImgWidth * tablero_padding_cards_mov; // espaciado

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto"; 
        });

      }

      break;

    case "7cards2":
      if (window.innerWidth >= 768) {
        // Escritorio (flecha hacia arriba con 7 cartas): altura 2x por punta a -1.5H
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card) / 100; // tamaño cartas
        y_tablero = (ImgWidth / proportionImg) * 12; // similar a 5cards1 pero con más margen
  x_tablero = 0;
        padding = ImgWidth * tablero_padding_cards; // espaciado

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto"; 
        });

      } else {
        // Móvil
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card_mov) / 100; // tamaño cartas
        y_tablero = (ImgWidth / proportionImg) * 12; // margen adicional en móvil
  x_tablero = 0;
        padding = ImgWidth * tablero_padding_cards_mov; // espaciado

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto"; 
        });

      }
      
      break;

    case "7cards3":
      if (window.innerWidth >= 768) {
        // Escritorio (flecha hacia abajo 7): altura 2x por punta a +1.5H
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card) / 100; // tamaño cartas
        y_tablero = (ImgWidth / proportionImg) * -12; // espejo de 7cards2
  x_tablero = 0;
        padding = ImgWidth * tablero_padding_cards; // espaciado

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto"; 
        });

      } else {
        // Móvil
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card_mov) / 100; // tamaño cartas
        y_tablero = (ImgWidth / proportionImg) * -12; // espejo en móvil
  x_tablero = 0;
        padding = ImgWidth * tablero_padding_cards_mov; // espaciado

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto"; 
        });
      }
      break;

    case "10cards1":
      if (window.innerWidth >= 768) {
        // Escritorio (Celtic Cross): cruz central + columna derecha; altura doble, centrado vertical
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card) / 100; // tamaño cartas
  // Calcular padding primero para poder centrar el conjunto por ancho total
  padding = ImgWidth * tablero_padding_cards; // espaciado
  y_tablero = (ImgWidth / proportionImg) * 0; // centrado vertical
  // Centro del bounding box: columna derecha está a +2W, el mínimo a -1W → desplazar -0.5W
  // Nota: x_tablero se resta en posiciones → valor positivo desplaza todo a la izquierda
  x_tablero = (ImgWidth + padding) * 0.5;
  // altura automática eliminada

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto";
        });

      } else {
        // Móvil (mismo criterio)
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card_mov) / 100; // tamaño cartas
  // Calcular padding primero para centrar correctamente (no permitir negativo)
  padding = Math.max(0, ImgWidth * tablero_padding_cards_mov - 5); // espaciado (mantiene ajuste previo)
  y_tablero = (ImgWidth / proportionImg) * 0; // centrado vertical
  // Desplazamiento para centrar bounding box (ver comentario en escritorio)
  x_tablero = (ImgWidth + padding) * 0.5;
  // altura automática eliminada

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto";
        });
      }
     
      break;

    // Custom spreads
    case "3cards3":
      if (window.innerWidth >= 768) {
          // Escritorio
          proportionImg = 100 / 10; // no cambiar
          ImgWidth = (tableroMedidas_x * tablero_size_card) / 100; // tablero, tamaño de las cartas.
          y_tablero = (ImgWidth / proportionImg) * -4; // tablero, mover arriba o abajo. Valido numeros negativos
          x_tablero = 0;
          padding = ImgWidth * tablero_padding_cards; // tablero, Espaciado entre cartas
  
          imgBorde.forEach(function (t) {
            t.style.width = ImgWidth + "px";
            t.style.height = "auto"; 
          });
  
        } else {
          // Movil
          proportionImg = 100 / 10; // no cambiar
          ImgWidth = (tableroMedidas_x * tablero_size_card_mov) / 100; // tablero, tamaño de las cartas.
          y_tablero = (ImgWidth / proportionImg) * 0; // tablero, mover arriba o abajo. Valido numeros negativos
          x_tablero = 0;
          padding = ImgWidth * tablero_padding_cards_mov; // tablero, Espaciado entre cartas
  
          imgBorde.forEach(function (t) {
            t.style.width = ImgWidth + "px";
            t.style.height = "auto"; 
          });
  
        }
      
      break;

    case "6cards1":

     if (window.innerWidth >= 768) {
        // Escritorio
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card) / 100; // tablero, tamaño de las cartas.
        y_tablero = (ImgWidth / proportionImg) ; // tablero, mover arriba o abajo. Valido numeros negativos
    x_tablero = 0;
  // Altura automática eliminada
        padding = ImgWidth * tablero_padding_cards; // tablero, Espaciado entre cartas

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto"; 
        });

      } else {
        // Movil
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card_mov) / 100; // tablero, tamaño de las cartas.
        y_tablero = (ImgWidth / proportionImg) * -7; // tablero, mover arriba o abajo. Valido numeros negativos
        x_tablero = 0;
  // Altura automática eliminada
        padding = ImgWidth * tablero_padding_cards_mov; // tablero, Espaciado entre cartas

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto"; 
        });

      }
      
      break;

    case "6cards2":
      if (window.innerWidth >= 768) {
        // Escritorio: 3 filas visibles (superior, media, inferior)
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card) / 100; // tamaño de las cartas
        y_tablero = (ImgWidth / proportionImg) * 2; // desplaza conjunto hacia arriba para dejar aire a la fila inferior
        x_tablero = 0;
  // Altura automática eliminada
        padding = ImgWidth * tablero_padding_cards; // espaciado entre cartas

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto";
        });

      } else {
        // Móvil: misma lógica, ajustada al perfil móvil
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card_mov) / 100; // tamaño de las cartas
        y_tablero = (ImgWidth / proportionImg) * -5; // desplaza hacia arriba
        x_tablero = 0;
  // Altura automática eliminada
        padding = ImgWidth * tablero_padding_cards_mov; // espaciado entre cartas

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto";
        });
      }
      
      break;

    case "7cards1":
      if (window.innerWidth >= 768) {
        // Escritorio: composición simétrica con rombos arriba/abajo. Altura ~2.4x
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card) / 100; // tamaño de las cartas
        y_tablero = (ImgWidth / proportionImg) * 0; // centrado vertical
        x_tablero = 0;
  // Altura automática eliminada
        padding = ImgWidth * tablero_padding_cards; // espaciado entre cartas

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto";
        });

      } else {
        // Móvil: misma lógica y multiplicador de altura
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card_mov) / 100; // tamaño de las cartas
        y_tablero = (ImgWidth / proportionImg) * 0; // centrado vertical
        x_tablero = 0;
  // Altura automática eliminada
        padding = ImgWidth * tablero_padding_cards_mov; // espaciado entre cartas

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto";
        });
      }
      break;

    case "7cards4":
      if (window.innerWidth >= 768) {
        // Escritorio: cuadrícula 3x3 simétrica (top=-H, mid=0, bottom=+H)
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card) / 100; // tamaño de las cartas
        y_tablero = (ImgWidth / proportionImg) * 0; // centrado vertical
        x_tablero = 0;
  // Altura automática eliminada
        padding = ImgWidth * tablero_padding_cards; // espaciado entre cartas

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto";
        });

      } else {
        // Móvil: misma lógica
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card_mov) / 100; // tamaño de las cartas
        y_tablero = (ImgWidth / proportionImg) * 0; // centrado vertical
        x_tablero = 0;
  // Altura automática eliminada
        padding = ImgWidth * tablero_padding_cards_mov; // espaciado entre cartas

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto";
        });
      }
      break;

    case "8cards1":
      if (window.innerWidth >= 768) {
        // Escritorio: 2 filas con pequeñas variaciones (1 está a -1.2H). Altura ~2.4x
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card) / 100; // tamaño cartas
        y_tablero = (ImgWidth / proportionImg) * 5; // centrado
        x_tablero = 0;
  // Altura automática eliminada
        padding = ImgWidth * tablero_padding_cards; // espaciado entre cartas

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto";
        });

      } else {
        // Móvil: misma lógica
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card_mov) / 100; // tamaño cartas
        y_tablero = (ImgWidth / proportionImg) * 5; // centrado
        x_tablero = 0;
  // Altura automática eliminada
        padding = ImgWidth * tablero_padding_cards_mov; // espaciado entre cartas

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto";
        });
      }
      break;

    case "8cards2":
      if (window.innerWidth >= 768) {
        // Escritorio: grid 3x3, top=-W y bottom=+W. Altura ~2.4x para evitar clipping
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card) / 100; // tamaño cartas
  // Centrado vertical para evitar que se salga por arriba/abajo
  y_tablero = (ImgWidth / proportionImg) * 0;
        x_tablero = 0;
  // Altura automática eliminada
        padding = ImgWidth * tablero_padding_cards; // espaciado entre cartas

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto";
        });

      } else {
        // Móvil: misma lógica
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card_mov) / 100; // tamaño cartas
  // Centrado vertical para evitar que se salga por arriba/abajo
  y_tablero = (ImgWidth / proportionImg) * 0;
        x_tablero = 0;
  // Altura automática eliminada
        padding = ImgWidth * tablero_padding_cards_mov; // espaciado entre cartas

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto";
        });
      }
      break;

    case "9cards1":
      if (window.innerWidth >= 768) {
        // Escritorio: top ~-1.3H y bottom ~+2.0H → altura ~2.6x para evitar clipping
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card) / 100; // tamaño cartas
        y_tablero = (ImgWidth / proportionImg) * -8; // centrado vertical
        x_tablero = 0;
  // Altura automática eliminada
        padding = ImgWidth * tablero_padding_cards; // espaciado

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto";
        });

      } else {
        // Móvil: mismo criterio de altura escalada
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card_mov) / 100; // tamaño cartas
        y_tablero = (ImgWidth / proportionImg) * 0; // centrado vertical
        x_tablero = 0;
  // Altura automática eliminada
        padding = ImgWidth * tablero_padding_cards_mov; // espaciado

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto";
        });
      }
      
      break;

    case "9cards2":
      if (window.innerWidth >= 768) {
        // Escritorio: fila media a 0, rombos arriba/abajo en ±1H; altura ~2.5x para margen de rotaciones
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card) / 100; // tamaño cartas
        y_tablero = (ImgWidth / proportionImg) * 0; // centrado vertical
  x_tablero = 40;
        padding = ImgWidth * tablero_padding_cards; // espaciado

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto";
        });

      } else {
        // Móvil: mismo criterio con ligera reducción de altura para evitar scroll excesivo
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card_mov) / 100; // tamaño cartas
        y_tablero = (ImgWidth / proportionImg) * 0; // centrado vertical
  x_tablero = 0;
        padding = ImgWidth * tablero_padding_cards_mov; // espaciado

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto";
        });
      }
      
      break;

    case "10cards2":
      if (window.innerWidth >= 768) {
        // Escritorio: grid 3x3 con carta central horizontal solapada; altura ~2.6x
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card) / 100; // tamaño cartas
        y_tablero = (ImgWidth / proportionImg) * 4; // centrado
  x_tablero = 0;
        padding = ImgWidth * tablero_padding_cards; // espaciado

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto";
        });

      } else {
        // Móvil: mismas proporciones con ligera reducción
        proportionImg = 100 / 10; // no cambiar
        ImgWidth = (tableroMedidas_x * tablero_size_card_mov) / 100; // tamaño cartas
        y_tablero = (ImgWidth / proportionImg) * 0; // centrado
  x_tablero = 0;
        padding = ImgWidth * tablero_padding_cards_mov; // espaciado

        imgBorde.forEach(function (t) {
          t.style.width = ImgWidth + "px";
          t.style.height = "auto";
        });
      }
      
      break;
  } // fin switch

  // Asegurar centrado en orientación horizontal para spreads por defecto (Xcards)
  try {
    if (image_orientation === 'h') {
      var isDefaultNumeric = /^(?:\d+)cards$/.test(String(spread || ''));
      if (isDefaultNumeric) {
        // Forzar offsets a 0 para centrar en el tablero
        y_tablero = 0;
        x_tablero = 0;
      }
    }
  } catch (_) { /* noop */ }

  return {
    ImgWidth,
    proportionImg,
    y_tablero,
    x_tablero,
    padding,
    moveCruz,
  };
}
